import { Validator } from '@vista-digital/validator';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultMemberContextAssets, memberContextAssetsValidator } from './assets';
import { defaultMemberContextDisplayText, memberContextDisplayTextValidator } from './display-text';
export const defaultMemberContextProps = {
    displayText: defaultMemberContextDisplayText,
    assets: defaultMemberContextAssets,
    children: undefined
};
export const memberContextPropsValidator = Validator.object({
    displayText: memberContextDisplayTextValidator,
    assets: memberContextAssetsValidator,
    children: reactChildrenValidator
});
